import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import OutlinedInput from '@mui/material/OutlinedInput';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import ListItemText from '@mui/material/ListItemText';
import InputAdornment from '@mui/material/InputAdornment';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import WarehouseIcon from '@mui/icons-material/Warehouse';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { getprocessingcenter } from '../redux/processingcenter';
import Progress from '../components/Loader';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function BasicModal() {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [personName, setPersonName] = React.useState([]);
  const [productPro, setProductPro] = React.useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');
  const dispatch = useDispatch();

  const names = ['Forklifts', 'Pallet jacks', 'Conveyors', 'Automated guided vehicles (AGVs)', 'Sorting systems'];
  const products = ['Maize', 'Soya Beans', 'Onion', 'Pepper', 'Tomatoes'];

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleSnackbarClose = () => setSnackbarOpen(false);

  const handleChange = (event) => {
    const { target: { value } } = event;
    setPersonName(typeof value === 'string' ? value.split(',') : value);
  };

  const handleChangeProduct = (event) => {
    const { target: { value } } = event;
    setProductPro(typeof value === 'string' ? value.split(',') : value);
  };

  const clearForm = () => {
    document.getElementById('centername').value = '';
    document.getElementById('address').value = '';
    document.getElementById('gpslocation').value = '';
    document.getElementById('contact').value = '';
    document.getElementById('capacity').value = '';
    document.getElementById('rawmat').value = '';
    document.getElementById('finished').value = '';
    document.getElementById('other').value = '';
    setPersonName([]);
    setProductPro([]);
  };

  const addWarehouse = async () => {
    setLoading(true);
    try {
      const res = await axios.post('https://embert.sisrevolution.com/api/center/addprocessingcenter/', {
        centername: document.getElementById('centername').value,
        address: document.getElementById('address').value,
        gpslocation: document.getElementById('gpslocation').value,
        contact: document.getElementById('contact').value,
        capacity: document.getElementById('capacity').value,
        rawmat: document.getElementById('rawmat').value,
        finished: document.getElementById('finished').value,
        product: productPro,
        equipments: personName,
      });

      if (res.status === 200) {
        setLoading(false);
        dispatch(getprocessingcenter({ data: res.data }));
        setSnackbarMessage('Processing center added successfully!');
        setSnackbarOpen(true);
        clearForm();
        setTimeout(() => handleClose(), 1500); // Close dialog after 1.5s
      } else {
        setLoading(false);
        setSnackbarMessage('Failed to add processing center.');
        setSnackbarOpen(true);
      }
    } catch (err) {
      setLoading(false);
      setSnackbarMessage('Error adding processing center.');
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <Button variant="outlined" startIcon={<WarehouseIcon />} onClick={handleOpen}>
        Add Processing Center
      </Button>
      <Dialog fullWidth minWidth="sm" open={open} onClose={handleClose} aria-labelledby="customized-dialog-title">
        <DialogTitle id="customized-dialog-title">
          Add New Processing Center
          <IconButton onClick={handleClose} style={{ float: 'right' }}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Box
            component="form"
            sx={{ '& .MuiTextField-root': { m: 1, width: '25ch' } }}
            noValidate
            autoComplete="off"
          >
            <TextField
              id="centername"
              label="Processing Center Name"
              type="text"
              autoComplete="current-text"
            />
            <TextField id="address" label="Address" type="text" autoComplete="current-text" />
            <TextField id="gpslocation" label="Location (GPS)" type="text" autoComplete="current-text" />
            <TextField id="contact" label="Contact" type="tel" autoComplete="current-text" />
            <TextField
              id="capacity"
              label="Processing Capacity"
              type="text"
              autoComplete="current-text"
              InputProps={{
                endAdornment: <InputAdornment position="end">Tons/day</InputAdornment>,
              }}
            />
            <TextField
              id="rawmat"
              label="Raw Material Storage Capacity"
              type="text"
              autoComplete="current-text"
              InputProps={{
                endAdornment: <InputAdornment position="end">Tons</InputAdornment>,
              }}
            />
            <TextField
              id="finished"
              label="Finished Products Storage Capacity"
              type="text"
              autoComplete="current-text"
              InputProps={{
                endAdornment: <InputAdornment position="end">Tons</InputAdornment>,
              }}
            />
            <FormControl sx={{ m: 1, width: 225 }}>
              <InputLabel id="demo-multiple-checkbox-label-products">Products Processed</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label-products"
                id="demo-multiple-checkbox-products"
                multiple
                value={productPro}
                onChange={handleChangeProduct}
                input={<OutlinedInput label="Products Processed" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {products.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={productPro.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ m: 1, width: 225 }}>
              <InputLabel id="demo-multiple-checkbox-label-equipment">Equipment</InputLabel>
              <Select
                labelId="demo-multiple-checkbox-label-equipment"
                id="demo-multiple-checkbox-equipment"
                multiple
                value={personName}
                onChange={handleChange}
                input={<OutlinedInput label="Equipment" />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {names.map((name) => (
                  <MenuItem key={name} value={name}>
                    <Checkbox checked={personName.includes(name)} />
                    <ListItemText primary={name} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField id="other" label="Processing Center Description" multiline rows={4} />
          </Box>
        </DialogContent>
        <Divider />
        <DialogActions>
          <div style={{ marginTop: 2, textAlign: 'center' }}>
            {loading ? (
              <Button variant="outlined" startIcon={<Progress />} disabled>
                Loading...
              </Button>
            ) : (
              <Button
                variant="outlined"
                startIcon={<WarehouseIcon />}
                size="large"
                onClick={addWarehouse}
              >
                Submit New Processing Center
              </Button>
            )}
          </div>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbarMessage.includes('success') ? 'success' : 'error'}
          sx={{ width: '100%' }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}